import type { ReactNode } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type Props = {
  url: string | null
  children: ReactNode
}

export const Container = ({ url, children }: Props) => {
  if (url) {
    return (
      <Anchor href={url} target="_blank" rel="noreferrer noopener">
        {children}
      </Anchor>
    )
  }

  return <Div>{children}</Div>
}

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: ${theme.colors.textTitle};

  @media screen and (max-width: 1047px) {
    row-gap: 20px;
  }
`

const Anchor = styled.a`
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;

  > h3 {
    color: ${theme.colors.trialBlue};
    text-decoration: underline;
    transition: color 0.3s ease-out;
  }

  &:hover > h3 {
    color: ${theme.colors.hover};

    > svg {
      fill: ${theme.colors.hover};
    }
  }

  @media screen and (max-width: 1047px) {
    row-gap: 20px;
  }
`
